import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
} from "../services/types/ComponentTypes";

export const screen_101_vehicles: ComponentConfig[] = [
  {
    componentType: LayoutTypes.SCREEN_GROUP,
    fabAction: {
      type: "add",
      screenId: "102",
    },
    title: "Vehicles",
    style: {
      backgroundColor: "#F9FAFB", // bg-gray-50 from design system
    },
    childComponents: [
      {
        componentType: LayoutTypes.GROUP,
        style: {
          backgroundColor: "#ffffff",
          direction: FlexDirection.COLUMN,
          borderRadius: 12, // Design system: rounded-lg (12px)
          // padding: 16, // Design system: p-4 (16px)
        },
        childComponents: [
          {
            componentType: ComponentType.SUMMARY_LIST,
            titleValue: "reg_no",
            Name: "vehicle_summary",
            style: {
              maxHeight: "calc(100vh - 350px)", // Adjust height to fit view
            },
            SummeryActions: [
              {
                Action: {
                  Action: "Navigate",
                  Navigate: "modulev1/vehicle_add/<id>",
                  Module: "Vehicle_Add",
                },
                ActionType: "Edit",
                ScreenId: "102",
                tooltip: "Edit Vehicle",
              },
              {
                Action: {
                  Action: "Delete",
                  Module: "vehicle_summary",
                },
                ActionType: "Delete",
                ScreenId: "101",
                tooltip: "Delete Vehicle",
              },
            ],
            Form: {
              Name: "vehicle_summary",
              TableName: "vehicle_details",
              View: "view_vehicle_details",
              Filter:
                "view_vehicle_details.soft_delete=0 order by view_vehicle_details.created_at desc",
              Fields: [
                {
                  IncludeLabel: true,
                  Label: "Reg No.",
                  BindValue: "txt_reg_no",
                  Json_Attribute: "reg_no",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Make",
                  BindValue: "s_select_vehicle_make",
                  Json_Attribute: "vehiclemake",
                  componentType: ComponentType.SEARCHABLE_DROPDOWN,
                  showInSummary: true,
                  LookupName: "vehicle_make",
                },
                {
                  IncludeLabel: true,
                  Label: "Type",
                  BindValue: "s_select_vehicletype",
                  Json_Attribute: "vehicletype",
                  componentType: ComponentType.SEARCHABLE_DROPDOWN,
                  showInSummary: true,
                  LookupName: "vehicletype",
                  IsMandatory: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Model",
                  BindValue: "txt_ModelYear",
                  Json_Attribute: "model_year",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                  IsMandatory: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Customer",
                  BindValue: "select_customer",
                  Json_Attribute: "customer_id",
                  componentType: ComponentType.SEARCHABLE_DROPDOWN,
                  showInSummary: true,
                  LookupName: "customers",
                  IsMandatory: false,
                },
                {
                  IncludeLabel: true,
                  Label: "Engine No.",
                  BindValue: "txt_enginesize",
                  Json_Attribute: "engine_no",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                  IsMandatory: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Chassis No.",
                  BindValue: "txt_chasisno",
                  Json_Attribute: "chasis_no",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                  IsMandatory: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Mulkkiya",
                  BindValue: "mulkkiya_attachment",
                  Json_Attribute: "mulkkiya_attachment",
                  componentType: ComponentType.FILES,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Others attachment",
                  BindValue: "Others_attachment",
                  Json_Attribute: "Others_attachment",
                  componentType: ComponentType.FILES,
                  showInSummary: true,
                },
              ],
            },
          },
        ],
      },
    ],
  },
];
